import CryptoJS from "crypto-js";
import { UserConfigs } from "../models/UserConfigs";
import { UsuarioService } from "../services/http/usuario.service";

const SECRET_KEY = "}yZ2Ab]pB[+tF3Cq^bDSSm[G.Rx4ePVp";

export class UserConfigsUtils {
  static manageUserConfigs(
    usuarioService: UsuarioService,
    isLogin: boolean
  ): void {
    usuarioService
      .getUserConfigs()
      .then((userConfigs: UserConfigs) => {
        if (!userConfigs?.ip) {
          this.removeUserConfigsStorage();
        } else {
          this.setUserConfigsStorage(userConfigs);
          if (isLogin) this.setUserConfigsLogin(usuarioService, userConfigs);
        }
      })
      .catch(() => {
        this.removeUserConfigsStorage();
      });
  }

  static getUserConfigsStorage(): UserConfigs | null {
    const encryptedUserConfigs = localStorage.getItem("UserConfigs");
    if (encryptedUserConfigs) {
      try {
        const bytes = CryptoJS.AES.decrypt(encryptedUserConfigs, SECRET_KEY);
        const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(decryptedData) as UserConfigs;
      } catch (error) {
        console.error("Error decrypting user configs:", error);
        this.removeUserConfigsStorage();
        return null;
      }
    }
    this.removeUserConfigsStorage();
    return null;
  }

  private static setUserConfigsStorage(config: UserConfigs): void {
    try {
      const encryptedData = CryptoJS.AES.encrypt(
        JSON.stringify(config),
        SECRET_KEY
      ).toString();
      localStorage.setItem("UserConfigs", encryptedData);
    } catch (error) {
      console.error("Error encrypting user configs:", error);
      this.removeUserConfigsStorage();
    }
  }

  static removeUserConfigsStorage(): void {
    localStorage.removeItem("ip");
    localStorage.removeItem("UserConfigs");
  }

  static setUserConfigsLogin(
    usuarioService: UsuarioService,
    userConfigs: UserConfigs
  ) {
    usuarioService.setUserConfigsLogin(userConfigs);
  }
}
